import { Reveal } from "./Reveal";

const stats = [
  { value: "7+", label: "Projects successfully completed", testid: "track-completed" },
  { value: "1", label: "Project currently under development", testid: "track-ongoing" },
  { value: "5", label: "Property opportunities being onboarded", testid: "track-onboarding" },
  { value: "₹4–27 Cr", label: "Project model range", testid: "track-range" },
];

export const TrackRecord = () => (
  <section id="track-record" className="bg-stone py-20 md:py-28" data-testid="track-record-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-spec text-[11px] uppercase tracking-[0.25em] text-amberdark">Why Urban Veera</p>
            <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-navy sm:text-4xl" data-testid="track-record-headline">
              We don't just look at properties. <span className="text-amber">We study them.</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-steel">
              Market, location, land potential, construction model and rental
              demand — we identify opportunities that actually make sense for
              the people putting in the capital.
            </p>
            <p className="mt-6 border-l-2 border-amber pl-4 text-sm font-bold leading-relaxed text-navy" data-testid="track-record-focus">
              Our focus is not quantity. It is selecting the right property,
              the right location and the right model.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-testid="track-record-grid">
            {stats.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.07}>
                <div
                  data-testid={s.testid}
                  className={`rounded-3xl p-8 ${i % 3 === 0 ? "bg-mist" : i % 3 === 1 ? "bg-butter" : "bg-peach"}`}
                >
                  <p className="font-display text-4xl font-extrabold tracking-tight text-navy sm:text-5xl">{s.value}</p>
                  <p className="mt-3 text-sm font-semibold leading-snug text-steel">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
